import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useFetch from '../../../../components/hooks/useFetch';
import SelectContratos from '../../../../components/form/SelectContratos';
import Select from '../../../../components/form/Select';
import MultiSelectCartoesPostagem from '../../../../components/form/MultiSelectCartoesPostagem';
import {
  PESQUISAR_CARTOES_CENTROCUSTO_PJ,
  PERMISSIONARIO_INCLUIR_CARTOES,
} from '../../../../services/delegacaoAcesso';
import { useForm } from 'react-hook-form';
import { getIPAddress } from '../../../../components/utils/GetIPAddress';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog';
import ModalDialog from '../../../../components/modal/ModalDialog.js';
import './TelaDelegacaoInclusao.scss';
import FormSistemas from './FormSistemas.js';

const TelaDelegacaoInclusao = () => {
  const { register, errors, control } = useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const { request } = useFetch();
  const [ipAddress, setIpAddress] = useState('');
  const dados = location.state.dados;
  const dadosPerfil = location.state.dadosPerfil;
  const dadosEmpresa = location.state.dadosEmpresa;
  const [dadosUsuarios, setDadosUsuarios] = useState(
    location.state.dadosUsuarios,
  );
  const [contratoSelecionado, setContratoSelecionado] = useState();
  const [cartoesFiltrados, setCartoesFiltrados] = useState();
  const { request: requestCentroCusto, data: dadosCentroCusto } = useFetch();
  const [cartao, setCartao] = useState([]);
  const [cartaoAdicionado, setCartaoAdicionado] = useState([]);
  const [modalAbertoSistemas, setModalAbertoSistemas] = useState(false);
  const [sistemasSelecionados, setSistemasSelecionados] = useState();
  const listaUsuarios = dadosUsuarios.map((usuario) => usuario.idCorreios);
  const fechar = () => {
    setModalAbertoSistemas(false);
  };
  const cancelar = () => {
    setModalAbertoSistemas(false);
    //chamaDelegacaoAcesso();
  };
  const abreModalSistamas = () => {
    setModalAbertoSistemas(true);
  };

  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };
    fetchIPAddress();
  }, []);

  const chamaDelegacaoAcesso = () => {
    navigate('/delegacaoAcesso', { state: { dados: dados, dadosPerfil } });
  };

  const deleteItem = (idCorreios) => {
    const updatedItems = dadosUsuarios.filter(
      (item) => item.idCorreios !== idCorreios,
    );
    setDadosUsuarios(updatedItems);
  };

  useEffect(() => {
    if (contratoSelecionado) {
      requestCentroCusto(
        PESQUISAR_CARTOES_CENTROCUSTO_PJ(
          dados.idCorreios,
          dadosEmpresa.usuarioExternoPJ.cnpj
            ? dadosEmpresa.usuarioExternoPJ.cnpj
            : dadosEmpresa.usuarioExternoPJ.an8,
          contratoSelecionado,
        ),
      );
    } else {
      limpaCartoes();
    }
  }, [contratoSelecionado]);

  function limpaCartoes() {
    if (cartao) {
      setCartao([]);
    }
  }

  const handleEscolherCentroCusto = (event) => {
    limpaCartoes();
    const centroSelecionado = dadosCentroCusto.filter(
      (item) => item.coCentroCusto == event.target.value,
    );
    if (centroSelecionado) {
      setCartoesFiltrados(centroSelecionado[0]?.cartoes);
    }
  };

  const adicionarCartao = () => {
    const novosValores = cartao
      .map((item) => item.value)
      .filter(
        (novoCartao) =>
          !cartaoAdicionado.some(
            (cartaoExistente) =>
              cartaoExistente.nuCartao === novoCartao.nuCartao &&
              cartaoExistente.nuContrato === novoCartao.nuContrato,
          ),
      );

    setCartaoAdicionado([...cartaoAdicionado, ...novosValores]);
  };

  const deleteCartaoAdicionado = (nuCartao) => {
    const updatedItems = cartaoAdicionado.filter(
      (item) => item.nuCartao !== nuCartao,
    );
    setCartaoAdicionado(updatedItems);
  };

  const salvar = async () => {
    if (dadosUsuarios.length < 1) {
      abreAlertaDialog('Selecione ao menos um Permissionário!');
      return;
    }
    let dadosEnviar = {
      listaUsuarios: dadosUsuarios.map((usuario) => usuario.idCorreios),
      listaCartoes: cartaoAdicionado,
      idCorreiosPF: dadosPerfil?.idCorreiosPF,
      perfil: dadosPerfil?.perfil,
    };

    const { response } = await request(
      PERMISSIONARIO_INCLUIR_CARTOES(
        dadosEmpresa.idCorreios,
        dadosEnviar,
        ipAddress,
      ),
    );

    if (response.ok) {
      abreAlertaDialog('Cartões incluídos  com sucesso!');
      //chamaDelegacaoAcesso();
    }
  };
  return (
    <>
      <div className="conteudo permissao-contrato">
        <h1>Permissões</h1>
        <h6>Usuários selecionados</h6>
        <div className="usuarios-selecionados">
          {dadosUsuarios?.map((item, index) => (
            <>
              <div className="chip chip-filter" key={item.idCorreios}>
                <div className="chip-txt">{item.nome}</div>
                <button
                  title="remover usuário"
                  className="btn-txt so-icone"
                  onClick={() => deleteItem(item.idCorreios)}
                >
                  <i className="ic-excluir-circulo"></i>
                </button>
              </div>
            </>
          ))}
        </div>
        <h2>
          <br />
          Adicionar cartões
        </h2>
        <div className="adicionar-cartoes elev1">
          <SelectContratos
            idCorreios={dadosEmpresa.idCorreios}
            dadosPerfil={dadosPerfil}
            inputRef={register}
            errors={errors}
            control={control}
            name="nuContrato"
            placeholder="Selecione"
            onChange={(contrato) => setContratoSelecionado(contrato)}
          />

          <Select
            options={
              contratoSelecionado && dadosCentroCusto
                ? [
                    { label: 'Selecione', value: '' },
                    ...dadosCentroCusto.map((item) => ({
                      value: item.coCentroCusto,
                      label: item.coCentroCusto,
                    })),
                  ]
                : [{ label: 'Centro Custo', value: '' }]
            }
            name="motivo"
            inputref={register}
            errors={errors}
            label="Centro de Custo"
            id="coCentroCusto"
            onChange={handleEscolherCentroCusto}
          />

          <MultiSelectCartoesPostagem
            options={
              contratoSelecionado && dadosCentroCusto && cartoesFiltrados
                ? [
                    ...cartoesFiltrados.map((item) => ({
                      value: item,
                      label: item.nuCartao,
                    })),
                  ]
                : []
            }
            inputRef={register}
            control={control}
            errors={errors}
            className="col-6"
            valor={cartao}
            aoMudar={setCartao}
          />

          <button className="btn-pre" onClick={() => adicionarCartao()}>
            Adicionar
          </button>
        </div>
        {/*<button className="btn-cont" onClick={() => salvar()}>
          <i className="ic-salvar"></i>Salvar cartões
        </button>*/}
        <span className="mini">
          <b>Cartões adicionados:</b>
        </span>
        <div className="cartoes-adidicionados">
          {cartaoAdicionado?.map((item, index) => (
            <>
              <div className="card-cartao" key={item.nuCartao}>
                <div>
                  <span className="mini">Contrato:</span>
                  {item.nuContrato}
                </div>
                <div>
                  <span className="mini">Centro Custo:</span>
                  {item.coCentroCusto}
                </div>
                <div>
                  <span className="mini">Cartão Postagem:</span>
                  {item.nuCartao}
                </div>
                <div>
                  <span className="mini">Status:</span>
                  {item.descricaoStatus ?? 'não validado'}
                </div>
                <button
                  title="remover usuário"
                  className="btn-txt so-icone"
                  onClick={() => deleteCartaoAdicionado(item.nuCartao)}
                >
                  <i className="ic-excluir-circulo"></i>
                </button>
              </div>
            </>
          ))}
        </div>
        <button className="btn-cont" onClick={() => salvar()}>
          <i className="ic-salvar"></i>Salvar cartões
        </button>
        <hr />
        <div>
          <h2>Permissões a sistemas</h2>
          <p className="sem-margem">
            Conceda acesso também aos sistemas para as pessoas selecionadas
          </p>
        </div>
        <button className="btn-cont" onClick={() => abreModalSistamas()}>
          <i className="ic-monitor"></i>Sistemas
        </button>
        {sistemasSelecionados ? (
          <span className="legenda">
            {sistemasSelecionados?.length} sistemas selecionados
          </span>
        ) : (
          <span className="legenda">Nenhum sistema seleconado</span>
        )}
        <hr />
        <div className="btns-row">
          <button className="btn-txt" onClick={() => chamaDelegacaoAcesso()}>
            Voltar
          </button>
        </div>
      </div>
      <ModalDialog
        titulo="Selecionar Sistemas"
        id="modal-novo"
        dialogClassName="selecionar-sistemas"
        aberto={modalAbertoSistemas}
        setAberto={setModalAbertoSistemas}
        opcaoFechar={false}
      >
        <FormSistemas
          acaoCancelar={cancelar}
          acaoFechar={fechar}
          listaUsuarios={listaUsuarios}
          ipAddress={ipAddress}
          dadosEmpresa={dadosEmpresa}
          dadosPerfil={dadosPerfil}
          incluir={true}
          sistemasSelecionados={(sistema) => setSistemasSelecionados(sistema)}
        />
      </ModalDialog>
    </>
  );
};
export default TelaDelegacaoInclusao;
